import React, { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import img1 from '../Assets/Plus-1.jpg';
import img2 from '../Assets/plus-10.jpg';
import img7 from '../Assets/plus-15.jpg';
import img3 from '../Assets/Plus-2.jpg';
import img4 from '../Assets/Plus-3.jpg';
import img9 from '../Assets/Plus-4.jpg';
import img5 from '../Assets/plus-6.jpg';
import img6 from '../Assets/plus-8.jpg';
import img8 from '../Assets/plus-9.jpg';

import formations from '../formations';
const CustomPrevArrow = ({ onClick }) => {
	const { hash } = useLocation();

	const scrollToElement = useCallback(() => {
		if (hash) {
			const target = document.querySelector(hash);
			if (target) {
				const yOffset = -100; // Negative offset
				const yPosition =
					target.getBoundingClientRect().top +
					window.pageYOffset +
					yOffset;
				window.scrollTo({ top: yPosition, behavior: 'smooth' });
			}
		}
	}, [hash]);

	useEffect(() => {
		// Slight delay to ensure DOM is fully rendered
		const timer = setTimeout(scrollToElement, 100);
		return () => clearTimeout(timer);
	}, [hash, scrollToElement]);

	return (
		<div
			onClick={onClick}
			style={{
				position: 'absolute',
				top: '50%',
				left: '0px',
				transform: 'translateY(-50%)',
				zIndex: 1,
				backgroundColor: '#87152B',
				borderRadius: '50%',
				padding: '10px',
				cursor: 'pointer',
				boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
			}}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				style={{ height: '20px', width: '20px', color: 'white' }}
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'
				strokeWidth={2}
			>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					d='M15 19l-7-7 7-7'
				/>
			</svg>
		</div>
	);
};

const CustomNextArrow = ({ onClick }) => {
	return (
		<div
			onClick={onClick}
			style={{
				position: 'absolute',
				top: '50%',
				right: '0px',
				transform: 'translateY(-50%)',
				zIndex: 1,
				backgroundColor: '#87152B',
				borderRadius: '50%',
				padding: '10px',
				cursor: 'pointer',
				boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
			}}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				style={{ height: '20px', width: '20px', color: 'white' }}
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'
				strokeWidth={2}
			>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					d='M9 5l7 7-7 7'
				/>
			</svg>
		</div>
	);
};

const FormationPlusCarousel = () => {
	const settings = {
		dots: false,
		infinite: true,
		autoplay: true,
		speed: 500,
		autoplaySpeed: 2000,
		cssEase: 'linear',
		slidesToShow: 3,
		slidesToScroll: 1,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
		]
	};
	const slideimgs = [
		{ id: 1, img: img1 },
		{ id: 2, img: img2 },
		{ id: 3, img: img3 },
		{ id: 4, img: img4 },
		// { id: 5, img: img5 },
		{ id: 6, img: img6 },
		{ id: 7, img: img7 },
		{ id: 8, img: img8 },
		{ id: 9, img: img9 }
	];

	return (
		<div className='flex items-center justify-center w-full'>
			<div className='w-full md:w-[80%] h-[400px] flex items-center justify-center bg-white'>
				<div className='w-[90%] h-full bg-white p-4 rounded-xl shadow border border-gray-100'>
					<h2 className='text-lg text-[#87152B] text-left font-semibold border-b-[#87152B]  border-b-2'>
						SUR LE TERRAIN ET EN BUREAU
					</h2>
					<Slider {...settings}>
						{slideimgs.map((slide) => (
							<div
								key={slide.id}
								className='slide-containerf rounded-xl'
							>
								<div className='h-full w-full flex items-center justify-center'>
									<img
										src={slide.img}
										alt={`Slide ${slide.id}`}
										className='w-full h-full object-cover'
									/>
								</div>
							</div>
						))}
					</Slider>
				</div>
			</div>
		</div>
	);
};

export default FormationPlusCarousel;
